import { ArrowsClockwiseIcon, CalendarBlankIcon, PaperPlaneTiltIcon } from '@phosphor-icons/react';
import type { CampaignType } from '../../types/campaigns.types';
import { CAMPAIGN_TYPE_STYLES } from '../../constants/campaigns.constants';

const typeIcons = {
  Regular: PaperPlaneTiltIcon,
  Scheduled: CalendarBlankIcon,
  Recurring: ArrowsClockwiseIcon,
} as const;

type CampaignTypeBadgeProps = {
  type: CampaignType;
};

export const CampaignTypeBadge = ({ type }: CampaignTypeBadgeProps) => {
  const Icon = typeIcons[type];
  const style = CAMPAIGN_TYPE_STYLES[type];

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium"
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      <Icon className="size-3.5 shrink-0" aria-hidden />
      {type}
    </span>
  );
};
